import { render, staticRenderFns } from "./modal-plan-invite.vue?vue&type=template&id=dec0083e&"
import script from "./modal-plan-invite.vue?vue&type=script&lang=ts&"
export * from "./modal-plan-invite.vue?vue&type=script&lang=ts&"
import style0 from "./modal-plan-invite.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports